import PaymentSummaryPage from './PaymentSummaryPage'

export default PaymentSummaryPage
